<template>
<li class="z-tree-node-wrap">
  <div
    :draggable="draggable"
    class="z-tree-node" :class="{
      selected,
      hover
    }" :style="{
      'padding-left': `${deep * 20 + 10}px`
    }"
    @click="onNodeClick(data)"
    @dblclick="onNodeDblclick(data)"
    @dragstart="ondragstart(data)"
    @dragover.prevent="ondragover"
    @dragleave="ondragleave"
    @drop.stop="ondrop(data)"
  >
    <span @click.stop="onNodeArrowClick"><i v-if="data.children" class="el-icon-caret-right" :class="{
      rotate: expanded
    }"></i></span>
    <label class="z-tree-node-label">{{data[nameProp]}}</label>
    <div><slot :node="data.srcData" /></div>
  </div>

  <div v-if="data.children" v-show="expanded">
    <ul class="z-tree-list">
      <z-tree-node
        v-for="child in data.children"
        :key="child.id"
        :data="child"
        :id-prop="idProp"
        :name-prop="nameProp"
        :parent-id-prop="parentIdProp"
        :show-checkbox="showCheckbox"
        :deep="deep + 1"
        :selected-id="selectedId"
        :default-expanded="defaultExpanded"
        :draggable="draggable"
        @node-click="onNodeClick"
        @node-dblclick="onNodeDblclick"
        @init-select="onInitSelect"
        @dragstart="ondragstart"
        @drop="ondrop"
      >
        <template v-if="$scopedSlots.default" slot-scope="{node}">
          <slot :node="node" />
        </template>
      </z-tree-node>
    </ul>
  </div>
</li>
</template>

<script>
export default {
  name: 'ZTreeNode',
  props: {
    data: {
      required: true,
      type: Object
    },
    idProp: {
      type: String,
      default: 'id'
    },
    nameProp: {
      type: String,
      default: 'name'
    },
    parentIdProp: {
      type: String,
      default: 'parentId'
    },
    showCheckbox: {
      type: Boolean
    },
    selectedId: {},
    deep: {
      type: Number,
      default: 0
    },
    defaultExpanded: {
      type: Boolean
    },
    draggable: {
      type: Boolean
    },
    leafSelectOnly: {
      type: Boolean
    }
  },
  data () {
    return {
      expanded: this.defaultExpanded,
      hover: false
    }
  },
  computed: {
    selected () {
      return this.selectedId === this.data[this.idProp]
    }
  },
  methods: {
    onInitSelect () {
      this.expanded = true
    },
    onNodeArrowClick () {
      this.expanded = !this.expanded
    },
    onNodeClick (data) {
      this.$emit('node-click', data)
    },
    onNodeDblclick (data) {
      this.$emit('node-dblclick', data)
    },
    ondragstart (data) {
      this.$emit('dragstart', data)
    },
    ondragover () {
      this.hover = true
    },
    ondragleave () {
      this.hover = false
    },
    ondrop (data) {
      this.hover = false
      this.$emit('drop', data)
    }
  },
  created () {
    if (this.selected) {
      this.$emit('init-select')
    }
  }
}
</script>

<style lang="scss">
.z-tree-node {
  display: grid;
  grid-template-columns: 14px auto max-content;
  grid-column-gap: 5px;
  align-items: center;
  line-height: 2;
  padding: 0 10px;

  &:hover,
  &.hover {
    background-color: var(--z-tree-node-hover-bg-color, #f5f7fa);
  }

  &.selected {
    color: #5cb6ff;
    background-color: var(--z-tree-node-selected-bg-color, #ecf5ff);
  }

  .z-tree-node-label {
    user-select: none;
  }

  .rotate {
    transform: rotate(90deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ZTree/ZTreeNode.vue